<template>
<v-main>

  <div v-if="!showEditLineKeys">
    <v-card class='mx-2 my-5 rounded-pill border-card' flat color='primary'>
      <v-card class='ma-0 pa-0 rounded-pill' outlined>
        <form @submit.prevent='dial'>
        <v-row no-gutters>
          <v-col class='ma-0 pa-0'>
            <v-card elevation='0' class='ma-0 pa-0 rounded-pill' height='100%' min-width='183%'>
            <input type="text" 
              v-model="number"
              placeholder="### ### ####"
              class="phoneNumberInput"
            >
            </v-card>
          </v-col>
          <v-col class='py-0 pl-0 pr-0' align='right'>
            <v-card elevation='0' class='ma-0 pa-0 rounded-r-pill btncard' height='102%' width='86' style='border-left: 5px solid #292961; '>
              <v-btn
                type='submit'
                class='dialer-btn'
                position: absolute
                dark
                rounded
                color='success'
                elevation='0'
                x-large
                block
                v-if="!showEditLineKeys"
              >
                <v-icon large>mdi-phone</v-icon>
              </v-btn>
            </v-card>
          </v-col>
        </v-row>
        </form>
      </v-card>
    </v-card>

    <v-tabs
        v-model="tab"
        background-color="transparent"
        grow
        class='ma-0 pa-0'
      >
        <v-tab class='ma-0 pa-0'>
          Favourites
          <app-line-key-settings v-if="tab==0"></app-line-key-settings>
        </v-tab>
        <v-tab class='ma-0 pa-0'>Recent</v-tab>
        <v-tab class='ma-0 pa-0'>Directory</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" class='tabItems'>
      <v-tab-item>
        <div  v-for="lk in lineKeys" :key="lk.line_key_id">
          <v-list-item v-if="!(lk.is_line && lk.is_line=='Y') && !lk.is_record && !lk.is_record_status" two-line>
            <v-list-item-icon>
              <v-icon v-if='checkBLF(lk) == "terminated"' color='green'>mdi-circle</v-icon>
              <v-icon v-else-if='checkBLF(lk) == "confirmed"' color='red'>mdi-circle</v-icon>
              <v-icon v-else-if='!checkBLF(lk)' color='gray'>mdi-circle</v-icon>
              <v-icon v-else color='orange'>mdi-circle</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{lk.label}}</v-list-item-title>
              <v-list-item-subtitle>{{lk.number}}</v-list-item-subtitle>
            </v-list-item-content>
            <v-spacer></v-spacer>

            <v-btn icon v-on:click="callLineKey(lk)">
              <v-icon>mdi-phone</v-icon>
            </v-btn>
          </v-list-item>
        </div>
          
      </v-tab-item>
      <v-tab-item>
      <div  v-for="call in callHistory" :key="call.uniqueid">
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title>{{callerName(call)}}</v-list-item-title>
              <v-list-item-subtitle>
                <v-icon small v-if="call.type=='incoming'">mdi-phone-incoming-outline</v-icon>
                <v-icon small v-if="call.type=='outgoing'">mdi-phone-outgoing-outline</v-icon>
                <v-icon small v-if="call.disposition=='NO ANSWER' || call.dst_voicemail_id">mdi-exclamation</v-icon>
                &nbsp;&nbsp;&nbsp;{{call.number}}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                {{call.calldate}}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-spacer></v-spacer>

            <v-list-item-action>
                <v-btn icon v-on:click="toggleFavourite(call)">
                  <v-icon v-if="isCallerFavourite(call)">mdi-star</v-icon>
                  <v-icon v-if="!isCallerFavourite(call)">mdi-star-outline</v-icon>
                </v-btn>  
            </v-list-item-action>

            <v-list-item-action>
              <v-btn icon v-on:click="callBack(call)">
                <v-icon>mdi-phone</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </div>
      </v-tab-item>
      <v-tab-item>
        <directory></directory>
      </v-tab-item>
    </v-tabs-items>

  </div>
</v-main>
</template>

<script>
import Common from "../mixins/common.vue";
import MinSession from "../components/MinSession.vue";
import LineKeySettings from "../components/line-key-settings.vue";
import Api from "../api.js";
import { mapState } from "vuex";
import Directory from "../components/directory";

export default {
  // components: { Icon },
  mixins: [Common],
  components: {
    "app-line-key-settings": LineKeySettings,
    'directory' : Directory,
    'minSession': MinSession
  },
    data: function () {
    return {
      pulsating: false,
      clipboardText: "",
      contact: { phonenumbers: {} },
      contacts: {},
      directory: {},
      groups: [],
      showDirectory: false,
      pastedNumber: "",
      tab: null,
      showEditLineKeys: false,
    };
  },
  computed: {
    ...mapState(["device"]),
    useVOIP: {
      get() {
        return this.$store.state.useVOIP;
      },
    },
 
    number: {
      get: function() { return this.$store.state.number; },
      set: function(v) { this.$store.commit('number',v)}
    },
    lineKeys: {
      get() {
        return this.$store.state.lineKeys;
      },
      set: function (v) {
        this.$store.commit("lineKeys", v);
      },
    },
    lineBLF: {
      get() {
        return this.$store.state.lineBLF;
      },
    },
    callHistory: {
      get() {
        return this.$store.state.callHistory;
      },
    },
  },
  watch: {
    showContactPopUp: function () {
      if (!this.showContactPopUp) {
        this.hideModal("directory");
      }
    },
  },
  methods: {
    debug: function (e) {
      console.log('debug:', e);
    },
    checkBLF: function(lineKey) {
      let lkBLF = this.lineBLF.find(e => e.number == lineKey.number);
      if (!lkBLF) return false;
      return lkBLF.blfState;
    },
    clipboardPopup: function () {
      this.showModal("numberOptionsVisible");
    },
    press: function (chars) {
      // Add the chars to the number
      this.number += chars;
    },
    selectExtension: function (extension) {
      this.number = extension;
      this.showDirectory = false;
    },
    callLineKey(lk) {
      this.number = lk.number;
      this.dial();
    },
    callBack(call) {
      this.number = call.number;
      this.dial();
    },
    onOpen: function () {
      this.sorting = !this.sorting;
    },
    onClose: function () {
      this.sorting = !this.sorting;
    },
    del: function () {
      this.number = this.number.substring(0, this.number.length - 1);
    },
    callerName: function (call) {
      let data = call.clid.split('" <');
      let str = data[0].replace('"', "");
      if (str == "") {
        str = data[1];
        str = str.replace(">", "");
      }
      return str;
    },
    dial: function () {
      if (this.useVOIP) {
        console.log("Making call with SIP");
        console.log(this);
        global.api.userAction('dial', this.number, 'webphone');
        this.$sip.dial(this.number);
      } else {
        this.$http.get(
          global.apiurl +
            "/clicktocall&" +
            "token=" +
            encodeURIComponent(this.click2call) +
            "&number=" +
            encodeURIComponent(this.number)
        );
      }

      this.pulsating = true;
      setTimeout(() => {
        this.pulsating = false;
      }, 5000);
    },
    showModal: function (name) {
      this.$modal.show(name);
    },
    showTheDirectory: function () {
      this.$router.push("/directory");
    },
    hideModal: function (name) {
      this.$modal.hide(name);
    },

    showContactVisible: function () {
      this.showModal("contactVisible");
    },
    isCallerFavourite: function (call) {
      for (let i = 0; i < this.lineKeys.length; i++) {
        let lk = this.lineKeys[i];
        if (call.number == lk.number) {
          return true;
        }
      }
      return false;
    },
    toggleFavourite: async function (call) {
      let api = new Api(global.gqlClient());
      if (this.isCallerFavourite(call)) {
        // get the favourite/linekey and remove it
        let newLineKeys = [];
        for (let i = 0; i < this.lineKeys.length; i++) {
          let lk = this.lineKeys[i];
          if (call.number == lk.number) {
            newLineKeys = await api.deleteLineKey(lk, this.device);
          }
        }
        this.lineKeys = newLineKeys;
      } else {
        // add the line key as a custom number
        let lineKey = await api.addCustomLineKey(
          this.callerName(call),
          call.number,
          this.device.device_id,
          this.click2call
        );
        console.log(lineKey);
        if (lineKey) {
          this.lineKeys.push(lineKey);
        } else {
          alert("Favourite not created: " + data.message);
        }
      }
    },
    //showDirectory: function() {
    //  this.updateDirectory();
    //  this.showModal('directory');

    //},
    cancelContact: function () {
      this.hideModal("directory");
    },
  },
  async mounted() {
    this.getMediaInputPermissionIfNotSet();
	try {

                let self = this;

                if(window.sforce) {
                        console.log('listening salesforce events');
                        window.sforce.opencti.enableClickToDial({ callback: (response) => {
                                console.log('Enabling click to call');
                                console.dir(response);
                        }});

                        window.sforce.opencti.onClickToDial({listener: (response) => {
                                console.log('Click to call enabled');
                                console.dir(response);

                                if(!response.number) {
                                        return;
                                }
                                console.dir(self);
                                try {
				this.number = "";
				this.number = response.number;
                                self.dial(response.number);
                                } catch(e) {
                                        console.error(e);
                                }

                                try {
                                        window.sforce.opencti.isSoftphonePanelVisible({callback: (response) => {
                                        console.dir(response);
                                        if (response.success) {
                                          console.log('API method call executed successfully! returnValue:', response.returnValue);
                                          if(!response.returnValue.visible) {

                                                window.sforce.opencti.setSoftphonePanelVisibility({visible: true, callback: (response) => {
                                                        console.log('-------------------------- opencall_back -----------');
                                                        console.dir(response);
                                                }});

                                        }
                                        } else {
                                            console.error('Something went wrong! Errors:', response.errors);
                                                }
                                        }});
                                } catch(e) {
                                }

                        }});
                }

        } catch(e) {
                console.error(e);
        }
  },
  filters: {
    phoneNumber: function (value) {
      return (
        value
          //.replace(/[^0-9]/g, '')
          .replace(/^(\d{3})(\d{3})(\d{4})$/, "($1) $2-$3")
          .replace(/^(\d{1})(\d{3})(\d{3})(\d{4})$/, "$1 ($2) $3-$4")
      );
    },
    emptySpace: function (value) {
      if (value == "") {
        return "- - -";
      } else {
        return value;
      }
    },
  },
};
</script>

<style scoped>
/* Works on Firefox */
* {
  scrollbar-width: thin;
  scrollbar-color: gray transparent;
}

/* Works on Chrome, Edge, and Safari */
*::-webkit-scrollbar {
  width: 8px;
}

*::-webkit-scrollbar-track {
  background: transparent;
}

*::-webkit-scrollbar-thumb {
  background-color: gray;
}

.tabItems {
  overflow:auto;
  height:calc(100vh - 235px);
}
.phoneNumberInput {
  font-size: 21pt;
  width: 100%;
  margin: 0px;
  padding: 22px 0px 22px 22px;
  outline: none;
  border-bottom: none!important;
}
.dialer-btn {
  border-radius:0px 50px 50px 0px;
  margin-top:-1px;
  min-height:102%;
}
.btncard {
  top:-1px;
}
.border-card {
  padding: 5px;
}
</style>
